<template>
	<div class="contacts">
		<a
			v-for="(contact, i) of contacts" :key="i"
			class="contact-link"
			:href="contact.link"
			:title="contact.title"
			target="_blank"
			>
			<i :class="contact.icon"></i>
		</a>
	</div>
</template>

<script>
export default {
	name: 'contacts',
	computed: {
		contacts() { return this.$store.state.contacts }
	}
}
</script>

<style lang="sass">
@import '../assets/css/smart-grid'

.contacts
	.contact-link
		font-size: 2.5rem
		margin-right: 1.5rem
		i
			transition: .2s all
			&.fa-telegram
				color: #30A8E4
			&.fa-vk
				color: #4A76A8
		&:hover
			i
				transform: scale(1.2)

@media screen and (max-width: $break_md)
	.contacts
		display: flex
		.contact-link
			font-size: 1.25rem
			margin-right: .75rem
</style>
